import service from '@/utils/server';

const modName='/bd/accessoryApprover/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const getIntEditData = data => {
  return service({
    url: modName + 'detail',
    method: 'post',
    data
  });
};

export const agree = data => {
  return service({
    url: modName + 'agree',
    method: 'post',
    data
  });
};

export const refuse = data => {
  return service({
    url: modName + 'refuse',
    method: 'post',
    data
  });
};






// WEBPACK FOOTER //
// ./src/page/bd/accessory/toExamine/api/index.js